import { message } from 'antd';

export const handleGenerateError = (error: any, retryCallback?: () => void) => {
  // Log detailed technical errors to Sentry (supports global window.Sentry injection)
  if (typeof window !== 'undefined' && (window as any).Sentry) {
    (window as any).Sentry.captureException(error);
  } else {
    // Fallback if Sentry is not imported top-level in frontend but backend tracks it
    console.error('[Sentry Fallback] Technical Error Intercepted:', error);
  }

  // Detect internet connectivity issues
  if (!navigator.onLine || error?.message === 'Network Error' || error?.code === 'ERR_NETWORK') {
    if (retryCallback) {
      message.error({
        content: 'Your internet is down. Please check your connection.',
        key: 'gen-network-error',
        duration: 4
      });
      console.log('Network error detected. Initiating automatic retry in 5s...');
      setTimeout(() => {
        if (navigator.onLine) {
          message.loading({ content: 'Reconnecting and retrying...', key: 'gen-retry' });
          retryCallback();
        } else {
          message.error({ content: 'Still offline. Please reconnect and try again.', key: 'gen-network-error' });
        }
      }, 5000);
    } else {
      message.error({
        content: 'Your internet is down. Please check your connection.',
        key: 'gen-network-error'
      });
    }
    return;
  }

  // Standardize error message for blog generation process failures
  message.error('Something went wrong. Please try again.');
};
